import routes from '@modules/training/training-routes';
import store from '@modules/training/training-store';

export default {
  routes,
  store,
};
